import { useEffect } from 'react';
import { ANNUAL, MONTHLY } from 'self-service-api/constants/Terms';
import { usePurchaseableProductsForApiName } from '../../../hooks/useBulkPurchaseOptions';
import { usePurchaseOptionsForProducts } from '../../../hooks/usePurchaseOptions';
import { trackTermSelectorInteraction } from '../../../v2/utils/tracking/trackingEventUtils';
import SkeletonLoadWrapper from '../loading/SkeletonLoadWrapper';
import { BaseTermSelectorComponent, getDiscountPercentageToShow } from './BaseTermSelectorComponent';
import { jsx as _jsx } from "react/jsx-runtime";
const DetailedTermSelector = ({
  productConfigurations = [],
  apiName,
  onChange,
  trackingSource,
  activeTerm,
  screen,
  compact = false
}) => {
  var _purchaseOptions$map, _getDiscountPercentag;
  const {
    loading: purchaseOptionsForProductsLoading,
    purchaseOptions: purchaseOptionsForProducts
  } = usePurchaseOptionsForProducts({
    productConfigurations
  });
  const {
    purchaseOptionsForApiName,
    loading: purchaseOptionsForApiNameLoading
  } = usePurchaseableProductsForApiName({
    apiName
  });
  const purchaseOptions = (productConfigurations === null || productConfigurations === void 0 ? void 0 : productConfigurations.length) > 0 ? purchaseOptionsForProducts : apiName ? purchaseOptionsForApiName : [];
  const purchaseOptionsLoading = purchaseOptionsForProductsLoading || purchaseOptionsForApiNameLoading;
  const availableTerms = (_purchaseOptions$map = purchaseOptions === null || purchaseOptions === void 0 ? void 0 : purchaseOptions.map(option => option.offerInfo)) !== null && _purchaseOptions$map !== void 0 ? _purchaseOptions$map : [];
  const [monthlyTerm, annualTerm] = availableTerms;
  const annualDiscountPercent = (monthlyTerm === null || monthlyTerm === void 0 ? void 0 : monthlyTerm.discount) === 0 ? annualTerm === null || annualTerm === void 0 ? void 0 : annualTerm.discount : (_getDiscountPercentag = getDiscountPercentageToShow(annualTerm === null || annualTerm === void 0 ? void 0 : annualTerm.discount, monthlyTerm === null || monthlyTerm === void 0 ? void 0 : monthlyTerm.discount)) !== null && _getDiscountPercentag !== void 0 ? _getDiscountPercentag : 0;
  const hasAnnualDiscount = annualDiscountPercent > 0;
  const discountMessage = `${Math.round(annualDiscountPercent)}PercentDiscount`;
  useEffect(() => {
    if (monthlyTerm && annualTerm) {
      const selectedTerm = activeTerm === MONTHLY ? annualTerm : monthlyTerm;
      trackTermSelectorInteraction({
        action: 'view',
        term: activeTerm,
        paymentTerm: selectedTerm === null || selectedTerm === void 0 ? void 0 : selectedTerm.payment,
        commitTerm: selectedTerm === null || selectedTerm === void 0 ? void 0 : selectedTerm.commitment,
        trackingSource,
        discountShown: discountMessage,
        screen,
        productNames: apiName ? [apiName] : []
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [monthlyTerm, annualTerm]);
  if (!purchaseOptionsLoading && (!purchaseOptions || !monthlyTerm || !annualTerm)) {
    return null;
  }
  const onToggleChange = () => {
    if (monthlyTerm && annualTerm) {
      const newQueryParamTerm = activeTerm === MONTHLY ? ANNUAL : MONTHLY;
      const selectedTerm = newQueryParamTerm === MONTHLY ? annualTerm : monthlyTerm;
      onChange(newQueryParamTerm);
      trackTermSelectorInteraction({
        action: 'click',
        term: newQueryParamTerm,
        paymentTerm: selectedTerm === null || selectedTerm === void 0 ? void 0 : selectedTerm.payment,
        commitTerm: selectedTerm === null || selectedTerm === void 0 ? void 0 : selectedTerm.commitment,
        trackingSource,
        discountShown: discountMessage,
        screen,
        productNames: []
      });
    }
  };

  // Adjust skeleton height based on compact prop
  const skeletonHeight = compact ? 36 : 54;
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: purchaseOptionsLoading,
    heights: [skeletonHeight],
    widths: [190],
    children: monthlyTerm && annualTerm && /*#__PURE__*/_jsx(BaseTermSelectorComponent, {
      onToggleChange: onToggleChange,
      trackingSource: trackingSource,
      activeTerm: activeTerm,
      availableTerms: availableTerms,
      hasAnnualDiscount: hasAnnualDiscount,
      compact: compact
    })
  });
};
export default DetailedTermSelector;